import {buildCommonGuideSettings, buildThemeSettings} from "./themeHelper.mjs";
import { GuideApiService } from '../services/GuideApiService.mjs';

const onDialogueStateInit = async (neuroState) => {
    const isDevelopmentMode = neuroState?.guideConfigurations?.runMode === 'development';
    const isDemoMode = neuroState?.guideConfigurations?.isDemoMode;
    const themeName = THEME_NAME || 'undefined';
    if( window?.ignite?.userService?.getGuideAttributes ) {
        const guideAttributes = await window.ignite.userService.getGuideAttributes();
        const dbThemeSettings = guideAttributes?.themeSettings || {};
        const dbGuideSettings = guideAttributes?.guideSettings || {};
        const themeSettings = buildThemeSettings(themeName, THEME_MANIFEST_CONFIGS || {}, dbThemeSettings, isDevelopmentMode, isDemoMode);
        const commonGuideSettings = buildCommonGuideSettings(dbGuideSettings, isDevelopmentMode, isDemoMode);

        if(guideAttributes?.dialogueApiConfig)
            await GuideApiService.authenicate(guideAttributes.dialogueApiConfig);

        GuideApiService.useUser(neuroState.user);
        GuideApiService.useAnswers(neuroState.answers);
        GuideApiService.useGuide(neuroState.guideConfigurations)

        return {
            ...neuroState,
            themeManifest: THEME_MANIFEST_CONFIGS || {},
            themeName,
            themeSettings,
            dialogueGuideSettings: {
                ...commonGuideSettings
            }
        }
    } else {
        return neuroState;
    }
}

export default onDialogueStateInit;
